import { Checkbox, DataSource, Layout } from "@mcleod/components";

export abstract class AutogenLayoutLMEUserDockOperations extends Layout {
    checkboxDockOperator: Checkbox;
    checkboxDockSupervisor: Checkbox;
    sourceUserSettings: DataSource;
}
